import React from "react";
import { useTranslation } from "react-i18next";
import { config } from "../../config/config";

export const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="mt-12 py-6 border-t border-gray-200 bg-white">
      <div className="flex flex-col items-end px-4 md:px-6">
        <a
          href={config.IMPRINT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-gray-500 hover:text-gray-700 transition-colors duration-200"
        >
          {t("dashboard.footer.imprint")}
        </a>
      </div>
    </footer>
  );
};
